import { createSlice } from '@reduxjs/toolkit';
import { v4 as uuid } from 'uuid';

const initialState = {
    ids: [],
    notifications: {},
};

function noop() {
    // do nothing!
}

export function buildNotification({
    id,
    variant,
    title,
    message,
    actions,
    autoDelete,
}) {
    const ad = parseInt(autoDelete);
    return {
        id: id || uuid(),
        variant,
        title,
        message,
        autoDelete: isNaN(ad) ? false : ad,
        actions: (actions || []).map(({ onClick, text }) => {
            if (typeof onClick !== 'function') {
                onClick = noop;
            }

            return { onClick, text };
        }),
    };
}

const notificationSlice = createSlice({
    name: 'notifications',
    initialState,
    reducers: {
        add: (state, action) => {
            const notification = buildNotification(action.payload);
            state.notifications[notification.id] = notification;
            state.ids.push(notification.id);
        },
        remove: (state, action) => {
            const notificationId = action.payload;
            const index = state.ids.indexOf(notificationId);
            if (index < 0) {
                return;
            }

            delete state.notifications[notificationId];
            state.ids.splice(index, 1);
        },
    },
});

export const { add, remove } = notificationSlice.actions;

export default notificationSlice.reducer;
